import React, { useMemo, useState } from 'react';
import { Button, Dropdown, Input } from 'antd';
import { SearchIcon, SortArrowIcon } from '@icons';

export default function SharedLinksTabControls({
  searchQuery,
  orderBy,
  onSearchChange,
  onOrderByChange
}: {
  searchQuery: string;
  orderBy: string;
  onSearchChange: (value: string) => void;
  onOrderByChange: (value: string) => void;
}) {
  const [selectedSorter, setSelectedSorter] = useState(orderBy);

  const items = useMemo(
    () => [
      {
        key: 'createdAt:DESC',
        label: (
          <>
            <span className="help_dropdown__dot" />
            Date created
          </>
        )
      },
      {
        key: 'visitsCounter:DESC',
        label: (
          <>
            <span className="help_dropdown__dot" />
            Views
          </>
        )
      },
      {
        key: 'active:DESC',
        label: (
          <>
            <span className="help_dropdown__dot" />
            Active first
          </>
        )
      }
    ],
    []
  );

  return (
    <div className="campaign-tab-controls" id="shared-links-tab-operations">
      <Input
        style={{
          width: '100%',
          maxWidth: 150,
          padding: '8px 12px'
        }}
        placeholder="Search links"
        prefix={<SearchIcon />}
        size="large"
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
      />
      <div className="campaign-tab-controls__actions">
        <Dropdown
          getPopupContainer={() =>
            document.querySelector('#shared-links-tab-operations') as HTMLElement
          }
          menu={{
            items: [
              {
                type: 'group',
                label: 'Sort by'
              },
              ...items
            ],
            selectedKeys: [selectedSorter],
            onClick: ({ key }) => {
              setSelectedSorter(key);
              onOrderByChange(key);
            }
          }}
          placement="bottomLeft"
          overlayClassName="help_dropdown"
          trigger={['click']}
        >
          <Button style={{ height: 'auto' }} type="text" icon={<SortArrowIcon />}>
            Sort
          </Button>
        </Dropdown>
      </div>
    </div>
  );
}
